import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { LogIn } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AdminLogin() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await login(email, pw); nav("/admin"); }
    catch { toast.error("Identifiants invalides"); }
    finally { setLoading(false); }
  };

  const googleLogin = () => {
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid place-items-center bg-deep-blue px-5 relative overflow-hidden" data-testid="admin-login">
      <div className="absolute inset-0 opacity-20" style={{background:"radial-gradient(600px 300px at 20% 20%, #D4AF37, transparent), radial-gradient(500px 300px at 80% 80%, #E07A5F, transparent)"}}/>
      <div className="relative w-full max-w-md bg-ivory rounded-2xl p-8 shadow-2xl">
        <Link to="/" className="text-xs uppercase tracking-widest text-warm-orange" data-testid="admin-back-home">← Retour au site</Link>
        <h1 className="font-display text-4xl text-deep-blue mt-4">Espace administrateur</h1>
        <p className="text-deep-blue/60 mt-2 text-sm">Accès réservé à l'équipe.</p>
        <form onSubmit={submit} className="mt-6 space-y-3">
          <input required type="email" placeholder="Email" value={email} onChange={e=>setEmail(e.target.value)} className="w-full p-3 rounded-lg border-2 border-black/5 focus:border-gold outline-none" data-testid="admin-email"/>
          <input required type="password" placeholder="Mot de passe" value={pw} onChange={e=>setPw(e.target.value)} className="w-full p-3 rounded-lg border-2 border-black/5 focus:border-gold outline-none" data-testid="admin-password"/>
          <button disabled={loading} className="btn-gold w-full py-3 rounded-full font-semibold inline-flex items-center justify-center gap-2" data-testid="admin-submit">
            <LogIn size={16}/> {loading?"Connexion…":"Se connecter"}
          </button>
        </form>
        <div className="my-4 text-center text-xs text-deep-blue/50">ou</div>
        <button onClick={googleLogin} className="w-full py-3 rounded-full font-semibold border-2 border-deep-blue text-deep-blue hover:bg-deep-blue hover:text-ivory transition" data-testid="admin-google">
          Continuer avec Google
        </button>
      </div>
    </div>
  );
}
